import styles from './ScrollChatImageProfiles.module.scss';

export interface ScrollChatImageProfilesProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

export const ScrollChatImageProfiles = ({
  children,
}: ScrollChatImageProfilesProps) => {
  return (
    <div
      className={styles.scrollContainer}
      data-test-id="scroll-chat-image-profiles-container"
    >
      {children}
    </div>
  );
};
